// src/Api/config.js

// Get credentials from environment variables (Vue CLI uses process.env)
const username = process.env.VUE_APP_USERNAME || '';
const password = process.env.VUE_APP_PASSWORD || '';

// Helper to safely encode credentials for Basic Auth
function getAuthHeader(user, pass) {
  if (!user || !pass) return '';
  // btoa is available in browsers, fallback for Node.js
  let encoded;
  try {
    encoded = btoa(`${user}:${pass}`);
  } catch (e) {
    if (typeof Buffer !== 'undefined') {
      encoded = Buffer.from(`${user}:${pass}`).toString('base64');
    } else {
      encoded = '';
    }
  }
  return `Basic ${encoded}`;
}

const authHeader = getAuthHeader(username, password);

const config = {
  username,
  password,
  authHeader
};

export default config;
